import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EdiDispatchParcelMapped } from '../edi-dispatch-parcel-management/edi-dispatch-parcel-management.component';

@Component({
  selector: 'lib-edi-dispatch-add-edit-parcel-modal',
  templateUrl: './edi-dispatch-add-edit-parcel-modal.component.html',
  styleUrl: './edi-dispatch-add-edit-parcel-modal.component.scss',
  standalone: false
})
export class EdiDispatchAddEditParcelModalComponent implements OnInit {
  @Input() parcel: EdiDispatchParcelMapped;

  isEdit: boolean = false;

  constructor(
    protected activeModal: NgbActiveModal
  ) {}

  ngOnInit(): void {
    if (!this.parcel) {
      this.parcel = {
        batchNumber: '',
        ginIdentifier: '',
        parentGinIdentifier: '',
        id: '',
        items: []
      };
      this.isEdit = false;
    } else {
      this.isEdit = true;
    }
  }

  save(): void {
    this.activeModal.close(this.parcel);
  }
}
